import { Modal } from "@mui/material";
import styled from "styled-components";
import ButtonComponent from "../button";
import IconCheck from "../../assets/images/icon-check-2.svg"
import IconFail from "../../assets/images/icon-fail.svg"

const Container = styled.div`
    width: calc(360px - 72px);
    /* height: calc(324px - 48px); */
    padding: 36px;
    border-radius: 16px;
    background-color: #FFFFFF;
    border: 1px solid #F1F1F190;
    box-shadow: 0px 5px 30px 0px #00266F29;
    display: flex;
    flex-direction: column;

    &:focus-visible {
        outline: none;
    }

    .image {
        margin-bottom: 24px;
    }

    .label {
        color: #25368D;
        font-size: 24px;
        font-weight: 500;
        line-height: 35.88px;
        text-align: center;
        margin-bottom: 8px;
    }

    .sub-label {
        color: #505050;
        font-size: 15px;
        font-weight: 400;
        line-height: 22.43px;
        text-align: center;
        white-space: pre-line;
        margin-bottom: 24px;
    }

    .button-container {
        margin-top: auto;
        margin-bottom: 0px;

        .button-box {
            width: 200px;
        }
    }
`;

function SuccessModal({
    open,
    title,
    subTitle,
    type,
    buttonLabel,
    styleContainer,
    onConfirm,
}) {
    function handleConfirm() {
        onConfirm && onConfirm();
    }

    return (
        <Modal
            className="content-center"
            open={open || false}
        >
            <Container
                style={{ ...styleContainer }}
            >
                <div className="image content-center">
                    <img alt="img" src={type === "fail" ? IconFail : IconCheck} />
                </div>
                <div className="label content-center">{title || ""}</div>
                <div className="sub-label content-center">{subTitle || ""}</div>
                <div className="button-container horizontal-center">
                    <div className="button-box">
                        <ButtonComponent
                            label={buttonLabel || "กลับหน้าหลัก"}
                            variant={"primary"}
                            sceenSize={"lg"}
                            style={{ maxWidth: "100%" }}
                            onClick={handleConfirm}
                        />
                    </div>
                </div>
            </Container>
        </Modal>
    )
}

export default SuccessModal;